module.exports = __webpack_public_path__ + "img/bottom-pic.caf8578b.png";